module.exports = __webpack_public_path__ + "img/640.378685cf.png";